<template>
  <div class="testwrap">
    <img src="../../assets/img/detailsimg.png" alt="" />
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.testwrap img {
  display: block;
  width: 100%;
}
</style>
